<template>
	<div class="app-container calendar-list-container">
		<basic-container>
			<el-row>
				<el-col :span="6">
					<el-scrollbar style="height: 606px; padding-right: 15px">
						<treeselect
							:maxHeight="600"
							ref="treeselect"
							:options="treeData"
							:cacheOptions="false"
							@select="getNodeData"
							alwaysOpen
							noChildrenText="没有子节点"
							noOptionsText="暂无数据"
							noResultsText="暂无结果"
							loadingText="加载中"
							@keydown.native="assetTreeKeydownFun"
							searchPromptText="暂无数据,可以输入关键字进行查询"
							:normalizer="normalizer"
							:appendToBody="true"
							@search-change="treeSearchChange"
							:load-options="Isasync ? asyncOptions : loadOptions"
							@open="itemopen"
							:async="Isasync"
							@close="itemClose"
							placeholder="输入关键字进行过滤"></treeselect>
					</el-scrollbar>
				</el-col>
				<el-col :span="18">
					<el-form ref="form" :label-position="labelPosition" :model="form" :rules="rules" label-width="80px">
						<el-card class="box-card" header="渠道信息" style="margin-bottom: 10px">
							<el-col :span="12">
								<el-form-item label="渠道名称" prop="name">
									<el-input v-model="form.name" readonly />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="注册手机" prop="loginMobile">
									<el-input v-model="form.loginMobile" readonly />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="登录名" prop="loginName">
									<el-input v-model="form.loginName" readonly />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="渠道属性" prop="channelAttr">
									<el-select v-model="form.channelAttr" disabled>
										<el-option
											v-for="item in channelAttrList"
											:key="item.value"
											:label="item.name"
											:value="item.value"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="渠道来源" prop="channelFrom">
									<el-select v-model="form.channelFrom" disabled>
										<el-option
											v-for="item in channelFromList"
											:key="item.value"
											:label="item.name"
											:value="item.value"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="渠道地区" prop="cityCode">
									<avue-cascader
										v-model="form.cityCode"
										:dic="areaList"
										:props="props"
										:show-all-levels="false"
										disabled></avue-cascader>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="状态" prop="status">
									<el-switch v-model="form.status" :active-value="1" :inactive-value="0" disabled></el-switch>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="停用状态" prop="insureAuthority">
									<el-input v-model="form.insureAuthority" readonly />
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="可用产品" prop="insureTypes">
									<el-checkbox-group v-model="form.insureTypes">
										<el-checkbox v-for="(itemData, index) in insureTypes" :key="index" :label="itemData.type" disabled>
											{{ itemData.name }}
										</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
							</el-col>
						</el-card>

						<el-card class="box-card" header="联系人" style="margin-bottom: 10px">
							<el-col :span="12">
								<el-form-item label="联系人" prop="contactPerson">
									<el-input v-model="form.contactPerson" readonly />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="联系手机" prop="contactPersonMobile">
									<el-input v-model="form.contactPersonMobile" readonly />
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="备注" prop="remark">
									<el-input v-model="form.remark" readonly />
								</el-form-item>
							</el-col>
						</el-card>

						<el-card class="box-card" header="结算信息" style="margin-bottom: 10px">
							<div v-for="({userName, idNo, bankName, cardNo}, index) in form.settleAccounts" :key="index">
								<el-col :span="12">
									<el-form-item label="结算人" prop="settleUserName">
										<el-input v-model="userName" readonly />
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="身份证号" prop="settleUserIdNo">
										<el-input v-model="idNo" readonly />
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="开户行" prop="settleBankName">
										<el-input v-model="bankName" readonly />
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="银行卡号" prop="settleBankCardNo">
										<el-input v-model="cardNo" readonly />
									</el-form-item>
								</el-col>
							</div>
						</el-card>
					</el-form>
				</el-col>
			</el-row>
		</basic-container>
	</div>
</template>

<script>
import {LOAD_CHILDREN_OPTIONS, ASYNC_SEARCH} from '@riophae/vue-treeselect'
import {fetchTree, getObj, distChannelByName} from '@/api/team/place'
import {areaList, dictList} from '@/api/dist/dict'
import {mapGetters} from 'vuex'
import Treeselect from '@riophae/vue-treeselect'

export default {
	name: 'Dept',
	components: {Treeselect},
	data() {
		return {
			treeData: [],
			filterText: '',
			list: null,
			total: null,
			formEdit: true,
			formAdd: true,
			formStatus: '',
			Isasync: false,

			typeOptions: ['0', '1'],
			methodOptions: ['GET', 'POST', 'PUT', 'DELETE'],
			listQuery: {
				name: undefined,
			},
			defaultProps: {
				children: 'children',
				label: 'name',
			},
			maxLength: 200,
			props: {
				label: 'areaName',
				value: 'areaCode',
			},
			rules: {},
			labelPosition: 'right',
			form: {
				name: undefined,
				sort: undefined,
				parentId: undefined,
				deptId: undefined,
				insureTypes: [],
			},
			channelAttrList: [],
			channelFromList: [],
			areaList: [],
			currentId: 0,
		}
	},
	created() {
		// this.getList()
		// this.getChannelAttrList()
		// this.getChannelFromList()
		// this.getAreaList()
		this.initTreeData()
	},
	mounted() {},
	computed: {
		...mapGetters(['insureTypes']),
	},
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val)
		},
	},
	methods: {
		async initTreeData() {
			let res = await this.getList({id: 0})
			let result = res.data.data
			//大于最多 200 条数据限制
			if (result.length > this.maxLength) {
				result.length = this.maxLength
			}
			this.treeData = result.map((item) => ({
				...item,
				children: item.leaf ? undefined : null,
			}))
		},
		async asyncOptions({action, searchQuery, callback}) {
			if (action === ASYNC_SEARCH) {
				let res = await this.getList({name: searchQuery})
				let result = res.data.data || []
				//大于最多 200 条数据限制
				if (result.length > this.maxLength) {
					result.length = this.maxLength
				}
				let options = result

				const expandAllChildren = function (data) {
					return data.map((item) => {
						const newItem = {...item, isDefaultExpanded: true}
						if (newItem.children && Array.isArray(newItem.children)) {
							newItem.children.isDefaultExpanded = true
							newItem.children = expandAllChildren(newItem.children)
						}
						return newItem
					})
				}

				const expandedOptions = expandAllChildren(options)
				console.log('expandedOptions', expandedOptions)
				callback(null, expandedOptions)
			}
		},
		itemopen() {
			this.Isasync = false
		},
		itemClose() {
			this.Isasync = false
		},
		async loadOptions({action, parentNode, searchQuery, callback}) {
			console.log('loadOptions', searchQuery, action, parentNode)

			//如果是点击展开下一级
			if (action === LOAD_CHILDREN_OPTIONS) {
				//加载点击节点的 子节点
				this.getList({id: parentNode.id}).then((response) => {
					parentNode.children = response.data.data
						? response.data.data.map((item) => ({
								...item,
								children: item.leaf ? undefined : null,
							}))
						: []
				})
				callback()
			}
		},
		getList({name, id}) {
			let query = {name, parentId: id}
			return distChannelByName(query)
		},
		getChannelAttrList() {
			dictList({fieldName: 'channel_attr'}).then((response) => {
				this.channelAttrList = response.data.data
			})
		},
		getChannelFromList() {
			dictList({fieldName: 'channel_from'}).then((response) => {
				this.channelFromList = response.data.data
			})
		},
		getAreaList() {
			areaList(2).then((response) => {
				this.areaList = response.data.data
			})
		},
		filterNode(value, data) {
			if (!value) {
				return true
			}
			return data.name.indexOf(value) !== -1
		},
		assetTreeKeydownFun(e) {
			//添加 loading
			const loading2 = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0)',
			})
			this.Isasync = true

			setTimeout(() => {
				loading2.close()
				if (!(e.target && e.target._value)) {
					this.Isasync = false
					this.initTreeData()
				}
			}, 50)
		},
		treeSearchChange(e) {
			console.log('treeSearchChange-e', e)
			setTimeout(() => {
				if (e) {
					this.Isasync = true
				} else {
					this.initTreeData()
					this.Isasync = false
				}
			}, 50)
		},
		normalizer(node) {
			return {
				id: node.id,
				label: node.name,
				children: node.children,
			}
		},
		getNodeData(data) {
			if (!this.formEdit) {
				this.formStatus = 'update'
			}
			getObj(data.id).then((response) => {
				let tempData = response.data.data
				let {insureTypes = ''} = tempData
				if (insureTypes === '' || insureTypes === 'ALL_VISIBLE') {
					insureTypes = this.insureTypes.map(({type}) => type)
				} else {
					insureTypes = insureTypes.split(',')
					insureTypes = insureTypes.map((itemData) => {
						return parseInt(itemData)
					})
				}
				tempData.insureTypes = insureTypes
				let temp = ''
				switch (tempData.insureAuthority) {
					case 'ALL':
						temp = '全部可用'
						break
					case 'OLD':
						temp = '禁止新保(可替换与新增)'
						break
					case 'REPLACE':
						temp = '禁止新保和新增(可替换)'
						break
				}
				tempData.insureAuthority = temp
				this.form = tempData
			})
			this.currentId = data.id
		},
	},
}
</script>

<style lang="scss" scoped>
/deep/ .el-card__header {
	padding: 8px 30px 8px 45px !important;
	font-size: 15px;
	font-weight: 300;
}

/deep/ .el-scrollbar__wrap {
	overflow-x: hidden;
	overflow-y: scroll;
	height: 100%;
}
</style>
